import { useAuth0 } from '@auth0/auth0-react';

import '../css_styles/button_styles.css'
import '../css_styles/window_canvas_styles.css'

// imports relevant for HTTP calls
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';

// ----- Imports for main window --------
import SampleEditorCycle from './workflow_elements/SampleEditorCycle'
import YesNoPopup from '../popup_windows/YesNoPopup';
import InfoPopup from '../popup_windows/InfoPopup';
import SelectOptionPopup from '../popup_windows/SelectOptionPopup';
import InfoExperimentalProcedure from './InfoExperimentalProcedure';

import UserSessionContext from '../user_session/context_user_session';
import { useContext, useState, useEffect } from 'react';


function WorkflowEditorCycle(props) {

    const [title, setTitle] = useState('')
    const [descriptionProcedure, setDesciptionProcedure] = useState('<p><em style="color: rgb(127, 127, 127);">Enter details about the experimental procedure ...</em></p>');
    const [workflow, setWorkflow] = useState({samples:[]});
    const [modifications, setModifications] = useState(false);

    const [showPopup, setShwoPopup] = useState(false);
    const [showCreateSuccess, setShowCreateSuccess] = useState(false);
    const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
    const [showNoModificationDetected, setShowNoModificationDetected] = useState(false)
    const [uuidExpSetup, setUuidExpSetup] = useState('');
    const [showPopupApplyAllCycles, setShowPopupApplyAllCycles] = useState(false)
    // ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const { user } = useAuth0();
    const [isLoading, setIsLoading] = useState(false);
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // ------------------ Display Object Validation Information/Warnings/Errors  ---------------------------------

    // If there is an active experimental setup -> then load it
    useEffect(() => {
        // if experimental workflow and associated campaign objects exist -> load these objects
        if (props.campaign_objects?.uuid_experimental_setup !== '' &&
            props.campaign_objects?.uuid_design_space !== '' &&
            props.campaign_objects?.uuid_objective !== '' ) {
            setIsLoading(true);
            setUuidExpSetup(props.campaign_objects.uuid_experimental_setup)
            fetch(`${SERVER_URL}/current_project/load_experimental_setup/`, {method: 'POST',
                                                            headers:{'Content-Type':'application/json',
                                                                     'uuid_tenant': usr_session_ctx.uuid_tenant},
                                                            body:JSON.stringify(props.campaign_objects.uuid_experimental_setup)})
            .then((res) => {
                if(!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                console.log(data)
                setWorkflow(data.data.workflow);
                setTitle(data.data.title);
                setDesciptionProcedure(data.data.description);
                setIsLoading(false); 
            })
            .catch((err) => {
                setException(true);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            });
        }
    }, []);

    // ------------- Handle Title --------------------------

    function handleTitle(event){
        setTitle(event.target.value);
        setModifications(true);
    }

    // ------------ Functions to Handle Samples --------------------------

    function handleSampleName(event) {
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[1]);
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id] = {...updatedSamples[sample_id],
                                        name: event.target.value };
        const updatedWorkflow = {...workflow, samples: updatedSamples};
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }


    // ------------ Functions to Handle Sample Elements --------------------------


    function handleElementName(event) {
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_id = parseInt(parser[3]);
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id].elements[element_id].name = event.target.value;
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }


    // ------------ Functions to Handle Cycle Data  --------------------------
    function handleCycleInfo(event){
        let parser = event.target.id.split('_');
        let key = parser[0]+'_'+parser[1];
        let sample_id = parseInt(parser[2]);
        let cycle_id = parseInt(parser[3]);
        let value = event.target.value;
        if (key !== 'cycletime_unit'){
            if(value !== ''){
                value = parseFloat(value);
                if( key === 'runparallel_min' || key === 'runparallel_max'){
                    value = Math.floor(parseFloat(value));
                }
                value = String(value);
                if (value<0) { value='';}
            }
        }
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id].cycles[cycle_id] = {...updatedSamples[sample_id].cycles[cycle_id], [key]: value };
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);

    }

    
    // ------------ Functions to Handle Save Experimental Setup --------------------------
    async function handleSave() {
        if (modifications === false ) {
            setShowNoModificationDetected(true);
            return;
        }
        if (props.cycleId === 0) {
            // if first cycle we can just save modifications of ExperimentalSetup objects
            await saveWorkflow()
        }
        if (props.cycleId > 0) {
            // if there are previous cycles, we let the user decide if the modfication are save to be applied to globally to all cycles that are based 
            // on the experimental setup, or if a new object ExperimentalSetup should be crated for this cycle and potnetially following cycles
            if(props.campaign_objects_prevcycle.uuid_experimental_setup === props.campaign_objects.uuid_experimental_setup){
                setShowPopupApplyAllCycles(true);
            }
            else{
                // if we update a workflow again for the same cycle there is not reason to re-create the workflow object that was not used yet
                await saveWorkflow()
            }
        }
    }

    async function apply2AllPrevCycles(){
        await saveWorkflow();
        setShowPopupApplyAllCycles(false);
    }

    async function saveAsNew(){
        await saveWorkflowAsNew();
        setShowPopupApplyAllCycles(false);
    }

    async function saveWorkflow() {
        setIsLoading(true);
        try{
            let update = {
                uuid_project: usr_session_ctx.session_info.uuid_current_project,
                uuid_opt_campaign: props.uuid_opt_campaign,
                uuid_exp_setup: uuidExpSetup,
                exp_setup: {
                    title: title,
                    description: descriptionProcedure,
                    workflow: workflow,
                } }
            let headers = {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/update_experimental_setup/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(update)
            });
            if(response.ok){
                await response.json();
                setModifications(false);
                setShowUpdateSuccess(true);
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }

    async function saveWorkflowAsNew() {
        setIsLoading(true);
        try{
            let update = {
                uuid_exp_setup: uuidExpSetup,
                uuid_opt_campaign: props.uuid_opt_campaign,
                cycle_id: props.cycleId,
                uuid_project: usr_session_ctx.session_info.uuid_current_project,
                exp_setup: {
                    title: title,
                    description: descriptionProcedure,
                    workflow: workflow,
                } }
            let headers = {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/update_experimental_setup_as_new/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(update)
            });
            if(response.ok){
                const uuid_new_exp_setup = await response.json();
                setModifications(false);
                setUuidExpSetup(uuid_new_exp_setup.data)
                setShowCreateSuccess(true);
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }


    function handleExit(){
        if(modifications===true) {
            setShwoPopup('true');
        }
        else{
            props.exit();
        }
    }

    function handleQillDescription(html) {
        setDesciptionProcedure(html);
        setModifications(true);
    }



    // ------------ Functions to Handle yes/no Popup window  --------------------------
    function onNo(){
        setShwoPopup(false);
    }

    function onYes(){
        props.exit();
    }

    function onOkCreate(){
        setShowCreateSuccess(false);
    }
    function onOkUpdate(){
        setShowUpdateSuccess(false);
    }
    function onOkNoModifications(){
        setShowNoModificationDetected(false);
    }


    let samples = workflow.samples.map((sample, sampleIndex) => (
        <SampleEditorCycle sid={`${sampleIndex}`}
                           key={`${sampleIndex}`}
                           handleSampleName={handleSampleName}
                           handleElementName={handleElementName}
                           handleCycleInfo={handleCycleInfo}
                           sample={sample}/>
        ));

    let editor = (<></>)
    if(isLoading && !Exception){
        editor = (<div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </div>);
    }

    else if(Exception){
        editor = (<>
                    <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                        <DisplayException>
                            {ExceptionMessage}
                        </DisplayException>  
                    </div>
                </>);
    }


    else if(!isLoading && !Exception){
        if(!showPopup){
            editor = (<>
                        <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                            <h3 style={{marginTop:'10px', marginLeft:'20px', padding:'0px', color:'var(--aixelo-red)'}}>Experimental Workflow Editor <br/><span style={{fontWeight:'normal'}}>restricted to ensure compatibility throughout this optimization campaign</span></h3>
                            <div style={{display:'flex'}}>
                                <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleSave}>Save</button>
                                <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px'}} onClick={handleExit}>Exit</button>
                            </div>
                            <input id='title' style = {{marginLeft:'20px', marginTop: '10px', marginBottom: '10px', border:'none', outline:'none', padding:'5px', position: 'relative',
                                                        borderLeft: '0.5px solid var(--aixelo-gray-light)', fontSize: '24px', fontWeight:'bold', width:'94%'}} 
                                            onChange = {handleTitle} value={title} autoComplete="false" type="text" placeholder="Enter Experimental Setup Title"  name="project_title" />
                            <div style = {{marginLeft: '20px', marginBottom: '15px', fontSize: '16px', position: 'relative', width:'fit-content'}} >
                                uuid: {uuidExpSetup}
                            </div>
                            <div style = {{width: `${props.width * 0.95 - 40}px`, marginLeft: '20px', background: 'white', marginTop: '10px', marginBottom: '20px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                                <InfoExperimentalProcedure 
                                    width={props.width*0.95 - 60}
                                    handleDescription={handleQillDescription}
                                    description={descriptionProcedure} />
                            </div>
                            <div style={{position: 'relative', marginLeft:'20px', height:'fit-content', width:`${props.width * 0.95 - 40}px`, overflow:'auto'}}>
                                {samples}
                            </div>
                        </div>
                    </>
                    );
        }

        if(showPopup){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <YesNoPopup ypos={'60px'} handleYes={onYes} handleNo={onNo}>
                        Modifications detected. Exit without saving?
                    </YesNoPopup>  
                </div>
            </>);
        }

        else if(showPopupApplyAllCycles){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <SelectOptionPopup ypos={'60px'} 
                        options = {['this cycle', 'all cycles']} 
                        actions = {[saveAsNew, apply2AllPrevCycles]}>
                        Do you want to apply the modifications to all previous cycles that are using the Experimental Workflow (uuid:{uuidExpSetup}) or only to this and future cycles? 
                    </SelectOptionPopup>  
                </div>
            </>);
        }

        else if(showCreateSuccess){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkCreate} >
                        Successfully updated Experimental Workflow as new Object:
                            <div style={{textAlign: 'left'}}>
                                <ul>
                                    <li style={{marginBottom:'5px'}}>uuid: {uuidExpSetup}</li>
                                </ul>
                       </div>
                    </InfoPopup>  
                </div>
            </>);
        }
        if(showUpdateSuccess){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkUpdate} >
                        Successfully updated Experimental Workflow (uuid:{uuidExpSetup})
                    </InfoPopup>  
                </div>
            </>);
        }
        else if(showNoModificationDetected){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkNoModifications} >
                       All objects are already up to date.
                    </InfoPopup>  
                </div>
            </>);
        }
    }

    return (<>{editor}</>);
}

export default WorkflowEditorCycle